// Persistence helpers for HR referral codes captured from `?ref=` query params.
// We persist to sessionStorage so the code survives navigation between the
// landing page and signup, but does not leak across browser sessions.

const REFERRAL_STORAGE_KEY = 'referralCode';

export function captureReferralFromUrl(search: string): string | null {
    if (typeof window === 'undefined') return null;
    const params = new URLSearchParams(search);
    const ref = params.get('ref');
    if (ref) {
        try {
            sessionStorage.setItem(REFERRAL_STORAGE_KEY, ref);
        } catch {
            // Ignore quota / privacy-mode errors — referral is non-critical.
        }
        return ref;
    }
    return null;
}

export function getStoredReferralCode(): string | null {
    if (typeof window === 'undefined') return null;
    try {
        return sessionStorage.getItem(REFERRAL_STORAGE_KEY);
    } catch {
        return null;
    }
}

export function clearStoredReferralCode(): void {
    if (typeof window === 'undefined') return;
    try {
        sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
    } catch {
        // ignore
    }
}
